import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { ReferralInfo } from '../types/domain';

export function referralEndpoints(http: HttpClient) {
  return {
    mine: () => http.get<ApiEnvelope<ReferralInfo>>('/v1/me/referrals').then(unwrap),
  };
}
export type ReferralEndpoints = ReturnType<typeof referralEndpoints>;
